export default __webpack_public_path__ + "static/media/video-square.8a9726c8.jpg";